<template>
    <div class="collectGoodsDialog">
        <el-dialog
            :title="title"
            :close-on-click-modal="false"
            :visible.sync="dialogDateVisible"
            append-to-body
            class="dialogActivityDateVisible"
        >
            <div class="dialogContent">
                <div class="titleTop">商品信息</div>
                <div class="dialogContent_box">
                    <div class="box_mess">
                        <p>店铺名称：</p>
                        <p>{{form.storeName}}</p>
                    </div>
                    <div class="box_mess">
                        <p>商家账号：</p>
                        <p>{{form.username}}</p>
                    </div>
                    <div class="box_mess" style="width:100%">
                        <p>商品名称：</p>
                        <p>{{form.goodsName}}</p>
                    </div>
                    <div class="box_mess">
                        <p>商品状态：</p>
                        <p>{{form.statusCn}}</p>
                    </div>
                    <div v-if="form.status == 'REJECT'" class="box_mess">
                        <p>驳回原因：</p>
                        <p>{{form.reason}}</p>
                    </div>

                    <!--<div class="box_mess">
                      <p>商品价格：</p>
                      <p>{{form.goodsPrice}}</p>
                    </div>
                    <div class="box_mess">
                      <p>兑换集采：</p>
                      <p>{{form.goodsCollect}}</p>
                    </div>-->
                    <div class="box_mess2">
                        <p>商品规格：</p>
                        <el-table
                            :data="activityGoodsSpecInfoList"
                            border
                            style="width: 100%">
                            <el-table-column
                                prop="goodsSpecName"
                                width="180"
                                label="商品规格名称">
                            </el-table-column>
                            <el-table-column
                                prop="goodsPrice"
                                label="商品价格(元)"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                prop="centralGoodsPrice"
                                label="集采价格(元)"
                                width="180">
                            </el-table-column>
                            
                        </el-table>
                        <!-- <p>{{form.goodsSpecName}}</p> -->
                    </div>
                </div>
                <div v-if="title == '审核'">
                    <div class="titleTop">审核</div>
                    <div class="auditContent">
                        <el-radio-group v-model="auditForm.status">
                            <el-radio label="PASS">通过</el-radio>
                            <el-radio label="REJECT">驳回</el-radio>
                        </el-radio-group>
                        <div class="cause" v-if="auditForm.status === 'REJECT'">
                            <div class="causeTitle">驳回原因：</div>
                            <div class="causeContent" style="width: 100%">
                                <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 5 }"
                                    placeholder="请输入驳回原因"
                                    v-model="auditForm.reason"
                                >
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <div class="auditEnter">
                        <el-button type="primary" @click="audit(form.uuid)">确定</el-button>
                        <el-button @click="dialogDateVisible = false"
                        >取消
                        </el-button
                        >
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        uploadFile,
        activitiesListByPage,
        activitiesList,
        getActivitiesDetails,
        saveActivities,
        publishActivities,
        delActivities,
        activitiesStoreListByPage,
        activitiesStoreList,
        activitiesGoodsListByPage,
        activitiesGoodsList,
        getActivitiesGoodsDetails,
        auditActivitiesGoods,
        activitiesStorePointListByPage,
        activitiesStorePointList,
        exchangeActivitiesStore
    } from "../../../utils/interface";

    export default {
        name: "collectGoodsDialog",
        data() {
            return {
                title: "",
                dialogDateVisible: false,
                form: {},
                auditForm: {},
                activityGoodsSpecInfoList: []
            };
        },
        methods: {
            init(type, goodsInfo) {
                if (type == "audit") {
                    this.title = "审核";
                    this.auditForm = {};
                } else if (type == "view") {
                    this.title = "查看";
                }
                this.auditForm.activityUuid = goodsInfo.activityUuid;
                getActivitiesGoodsDetails(goodsInfo.uuid).then((res) => {
                    if (res.success && res.data) {
                        this.form = {
                            uuid: res.data.uuid,
                            storeName: res.data.storeName,
                            username: res.data.username,
                            goodsName: res.data.goodsName,
                            status: res.data.status,
                            statusCn: res.data.statusCn,
                            reason: res.data.reason,
                        };
                        this.activityGoodsSpecInfoList = res.data.activityGoodsSpecInfoList;
                    }
                });
                this.dialogDateVisible = true;
            },
            // 保存发布
            audit(uuid) {
                if (this.auditForm.status === undefined) {
                    this.$message.warning("请选择审核结果！");
                } else if (this.auditForm.status === "REJECT" && this.auditForm.reason === undefined) {
                    this.$message.warning("请输入驳回原因！");
                } else {
                    this.auditForm.uuid = uuid;
                    auditActivitiesGoods(this.auditForm).then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                        } else {
                            this.$message.error(res.message);
                        }
                        this.dialogDateVisible = false;
                        this.$emit('refresh');
                    });
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    .dialogActivityDateVisible {
        /deeep/ .el-dialog__body {
            padding-left: 30px !important;
            padding-right: 30px !important;
        }
    }

    .dialogContent {
        .titleTop {
            font-size: 20px;
            margin-bottom: 26px;
            padding-left: 48px;
            border-top: 1px solid #efefef;
            padding-top: 30px;

            &:nth-of-type(1) {
                border-top: none;
                padding-top: 0;
            }
        }
    }

    .dialogContent_box {
        display: flex;
        flex-wrap: wrap;
        margin: 0 50px;

        .box_mess {
            width: 50%;
            display: flex;
            margin-bottom: 15px;

            img {
                width: 300px;
                height: 150px;
            }
            p:nth-of-type(1){
                white-space: nowrap;
            }
        }

        .box_mess2 {
            margin-bottom: 15px;
        }
    }

    .auditContent {
        padding-left: 48px;

        .cause {
            display: flex;
            margin-top: 20px;

            .causeTitle {
                min-width: 80px;
                color: #3a8ee6;
            }

            .causeContent {
                color: #000;
            }
        }
    }

    .auditEnter {
        text-align: center;
        padding-top: 20px;

        button {
            width: 120px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/collectManage/collectDialog/collectGoodsDialog.vue